function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6204 17.9993H10.7858L13.8565 25.4364C14.0704 25.952 13.826 26.5301 13.3371 26.7489L10.633 27.9207C10.1289 28.1394 9.56362 27.8894 9.34972 27.3894L6.43181 20.3273L1.66529 25.202C1.03009 25.8516 0 25.3508 0 24.499V1.00096C0 0.104082 1.09565 -0.333145 1.66523 0.297894L17.3079 16.2963C17.9389 16.9076 17.4733 17.9993 16.6204 17.9993Z",
  fill: "#33D5BA"
});
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6d1e477bf80941c1f14ddff22d59cf57.svg";
export { ForwardRef as ReactComponent };